import getConfig from 'next/config';
import is from 'is_js';

import { setLocaleData, setNewsData, setProducts } from '../actions/load';
import { setSelectedAssetTab } from '../actions/settings';
import makeApiRequest from '../utils/makeApiRequest';
import makeOrCacheApiReq from '../utils/apiCache';
import { getLocalCacheKey } from '../utils/locales';
import { getHostName } from '../utils/urlUtils';
import { readCookie } from '../utils/cookies-browser';
import metaInfo from '../config/metaInfo';
import API_PATH from '../actions/actionsFactory/apiPath';
import { gwGet } from '../actions/actionsFactory/gwRequest';
import { handleGwData } from '../actions/actionsFactory';
import {
  fetchNotice,
  fetchRecommendInfo,
  getRecommendsRequest,
} from '../actions/actionsSet/market';
import { getHeaderConfig } from './GetBaseInitialProps';
import { setPublicAssetsStatus, hideHeaderLangSelect } from '../actions/actionsSet/userConfig';
import { wssUri } from './handleInitTask';

const {
  publicRuntimeConfig: { routePrefix: ROUTE_PREFIX, site },
} = getConfig();

const {
  brands, metaTitles, metaKeywords, metaDescriptions,
} = metaInfo;

// node apis served in server.js
const TIME_API_PATH = `${ROUTE_PREFIX}/api/v1/time`;
const I18N_API_PATH = locale => `${ROUTE_PREFIX}/en/i18n/${locale}.json`;

// !!! only ONE `await` allowed in this code !!!

export default async ({
  isServer, req, query, store, ...rest
}) => {
  // only ONE `await` allowed in this code
  const promises = []; // do requests ASYNC
  const locale = (query || {}).locale || 'en';
  const localeCacheKey = getLocalCacheKey(locale);
  const setCacheKey = name => `${name}${localeCacheKey}`;
  const state = store.getState();
  let ua = '';
  try {
    ua = rest?.res?.req?.headers['user-agent'] || '';
    // eslint-disable-next-line no-empty
  } catch (_) {}

  let selectedAssetTab = isServer ? req.cookies.defaultAssetTab : readCookie('defaultAssetTab');
  if (selectedAssetTab === 'USD') selectedAssetTab = 'USDⓈ';

  if (selectedAssetTab) store.dispatch(setSelectedAssetTab(selectedAssetTab));

  // ** End A/B TEST code **

  const shouldPublicAssets = isServer
    ? req.cookies.shouldPublicAssets
    : readCookie('shouldPublicAssets');
  store.dispatch(setPublicAssetsStatus(shouldPublicAssets === 'true'));

  const isHideHeadLangSeclet = isServer
    ? req.cookies.isHideHeadLangSeclet
    : readCookie('isHideHeadLangSeclet');
  store.dispatch(hideHeaderLangSelect(isHideHeadLangSeclet === 'true'));

  const isOurUser = isServer ? req.cookies.isOurUser : readCookie('isOurUser');

  // 1
  promises.push(
    is.empty(state.tickers)
      ? makeOrCacheApiReq(
        `${API_PATH.PRODUCTS_API_PATH}_${locale}`,
        () => gwGet(API_PATH.PRODUCTS_API_PATH, { locale }, req),
        res => res.success && Array.isArray(res.data)
      )
      : {}
  ); // 1

  // 2
  // uses locale, cache key = ACTIVITIES_API_PATH + locale
  promises.push(fetchRecommendInfo(req, locale, site || 'global')); // 2

  // 3 - serverTime
  promises.push(
    isServer
      ? Promise.resolve({ serverTime: Date.now() })
      : makeApiRequest(TIME_API_PATH, req, null, null, true)
  );

  // 4
  // uses locale too, see above
  promises.push(
    makeOrCacheApiReq(
      setCacheKey(API_PATH.RECOMMENDS_API_PATH),
      () => getRecommendsRequest(locale, req),
      res => res.success && Array.isArray(res.data)
    )
  );

  let localeData = store.getState().localeData[locale];
  let news = store.getState().news[locale];

  if (!localeData) {
    // 7
    promises.push(
      makeOrCacheApiReq(`beta-i18n-${locale}`, () => makeApiRequest(I18N_API_PATH(locale), req, null, null, true)
      )
    ); // 7
  }
  if (!news) {
    // 8
    // uses locale too, see above
    promises.push(fetchNotice(req, locale)); // 8
  }

  // FETCH in parallel
  const [products, activities, serverTime, recommends, ...responses] = await Promise.all(promises);

  // 5
  if (!localeData) localeData = responses.shift();
  store.dispatch(setLocaleData(locale, localeData));

  // 6
  if (!news) {
    news = responses.shift();
    store.dispatch(setNewsData(locale, news));
  }

  if (!is.empty(products)) store.dispatch(setProducts(handleGwData(products)));

  await getHeaderConfig(store, req, locale)

  // JUST data for this page, not shared
  return {
    isOurUser,
    metaData: {
      title: metaTitles[locale] || metaTitles.en || `${localeData.Binance || brands[locale]}`,
      keywords: metaKeywords[locale] || metaKeywords.en || '',
      description: metaDescriptions[locale] || metaDescriptions.en || '',
    },
    ActivitiesData: activities,
    ServerTime: serverTime && serverTime.serverTime,
    Recommends: handleGwData(recommends),
    wssUri: wssUri(req),
    hostName: getHostName(req),
    ua,
  };
};
